import React,{Component} from 'react';
import Title from '../Title/Title';


export default class DefaultPage extends Component {
  render(){
  return (
   <div>
        <Title name="ERROR" title="PAGE NOT FOUND"/>
   </div>
  );
}
}